<script setup lang="ts">
import FortuneWheel from '@/assets/images/fortune-wheel.webp'
import GoldenWheel from '@/assets/images/golden-wheel.png'
import { T } from '@tolgee/vue'
import CheckIcon from '@/components/icons/CheckIcon.vue'
import { twMerge } from 'tailwind-merge'
import { computed, onMounted } from 'vue'

const props = defineProps<{
	streak: { index: number, active: boolean, completed: boolean }[]
	allDone?: boolean
	blur?: boolean
	completedStreakCount?: number,
	isTodayClaimed?: boolean
}>()

const emit = defineEmits<{
	(e: 'loaded'): void
}>()

const progressCount = computed(() => (((props.completedStreakCount ?? 0) + (+!props.isTodayClaimed) - 1) % props.streak.length) + 1)

const progressStyle = computed(() => {
  if (props.allDone) {
    return {
      width: '100%',
    }
  }
  return {
    width: `calc((${progressCount.value} * ((100% - 56px) / ${props.streak.length})) + (${+(progressCount.value > 0)} * 28px))`,
  }
})

onMounted(() => emit('loaded'))
</script>
<template>
  <div
    :class="twMerge('rounded-[25px] py-0.5 bg-dark-top-most-layer h-5 flex items-center text-black text-xs relative w-full max-w-[343px]', blur && 'bg-transparent')"
  >
    <img
      :src="FortuneWheel"
      class="absolute left-[-2px] top-1/2 -translate-y-1/2  size-7 z-[2] object-cover"
    >
    <div
      :class="twMerge('absolute left-0 top-1/2 -translate-y-1/2 rounded-[25px] h-4 transition-all', allDone ? 'bg-[#FFF246]' : 'bg-teal-primary', blur && 'bg-[rgba(255,242,70,0.44)] backdrop-blur-[12px]')"
      :style="progressStyle"
    />
    <div class="flex items-center justify-center w-full px-7">
      <div
        v-for="(day, index) in streak"
        :key="index"
        :class="twMerge('flex-1 flex items-center pr-2 h-full',
                        day.completed && day.active && 'rounded-br-[25px] rounded-tr-[25px]',
        )"
      >
        <div :class="twMerge('flex items-center w-full z-[4] justify-center')">
          <CheckIcon
            v-if="allDone || (day.completed && !day.active)"
            class="w-[10.5px] h-[8.5px] text-tropee-black"
          />
          <span
            v-else
            class="flex items-center"
          >
            <span
              v-if="day.active && index === 0"
              class="mr-0.5 text-xs font-medium tracking-[1px]"
            >
              <T
                key-name="fortune_wheel.day"
                default-value="Day "
              />
            </span>
            <span :class="twMerge('font-bold text-xs text-tropee-black', (progressCount - 1 < index && index !== 0) && 'text-white/60')">
              {{ day.index }}
            </span>
          </span>
        </div>
      </div>
    </div>
    <div class="rounded-full absolute right-0 top-1/2 -translate-y-1/2  size-7 z-[2] bg-dark-top-most-layer flex items-center justify-center">
      <img
        :src="GoldenWheel"
        class="h-[26px] w-[26px] min-w-[26px]"
      >
    </div>
  </div>
</template>